<template>
  <SiteLayout>
    <router-view name="site"/>
  </SiteLayout>
</template>

<script>
import SiteLayout from "./SiteLayout.vue";

export default {
  name: "SiteTemplate",
  components: {SiteLayout},
}
</script>

<style scoped>

</style>